import reduxCrud from 'redux-crud';

const stopsReducers = reduxCrud.Map.reducersFor('stops', { key: 'id' });

export default stopsReducers;
